
import React from 'react'
import { Component } from 'react'

import Ding from './Ding'
import Tree from './Tree'
import SearchLink from 'cms_plugins/expert_search/js/components/SearchLink'
import MultiSelector from "../../../expert_search/js/components/MultiSelector";


export const TABS_CHOICES = ["Zitat", "Typisierung", "Dinge"];

const DESC_LENGTH=150

class Zitat extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tabs: { "Zitat": true }
        }
    }

    showMore(pk) {
        var dots = document.getElementById("dots" + pk);
        var moreText = document.getElementById("more" + pk);
        var btnText = document.getElementById("show-more-btn" + pk);

        if (dots.style.display === "none") {
            dots.style.display = "inline";
            btnText.innerHTML = "(weiterlesen)";
            moreText.style.display = "none";
        } else {
            dots.style.display = "none";
            btnText.innerHTML = "(weniger)";
            moreText.style.display = "inline";
        }
    }

    reduceText(text, id) {
        let f = DESC_LENGTH
        
        if (text.length <= f) {
            return text
        }

        if (text.slice(0,f).lastIndexOf("&")>text.slice(0,f).lastIndexOf(";") ){
            f=f+ text.slice(f,text.length).indexOf(";")+1
        }

        let reg = text.slice(0, f).match(/<[^>]*>/g)
        if (reg && reg[reg.length - 1] != "<br>" && reg[reg.length - 1].charAt(1) != "/")
            f = text.slice(0, f).lastIndexOf(reg[reg.length - 1])

        return text.slice(0, f) +
            "<span id=\"dots" + id + "\">...</span><span class=\"more\" id=\"more" + id + "\">"
            + text.slice(f, text.length - 1) + "</span>"
    }

    renderSeeAlso(see_also_list){
        let see_also_essential=[]

        for (let i = 0; i < see_also_list.length; i++) {
            if (!see_also_essential.find(v => v.name == see_also_list[i].name)) {
                see_also_essential.push(
                    {
                        "name": see_also_list[i].name,
                        "years": [see_also_list[i].year]
                    }
                )
            }
            else
                see_also_essential.map((item) => {
                    if (item.name == see_also_list[i].name) {
                        item.years.push(see_also_list[i].year)
                    }
                }
                )
        }

        return (
            see_also_essential.map(
                (item, i)=> (
                    <span>
                        
                        <SearchLink
                                text={item.name}
                                model={"Metapher"}
                                field={"Text"}
                            title={(item.years.length > 1 ? "Jahre: " : "Jahr: ") +
                                item.years.join(", ")
                            }
                            />
                            {i + 1 < see_also_essential.length ? <span>,</span> : null}
                            &nbsp;
                                                    
                        </span>
                )
            )
        )
    }

    render() {
        const {
            pk, year, text_html, metapher, source, things, comment,
            zitat_edit_url
        } = this.props;
        const own_selector = !this.props.tabs;
        const tabs = own_selector ? this.state.tabs : this.props.tabs;

        return (
            <div className="zitat grid-x" id={"zitat-" + pk}>
                <div className={"small-8 cell"}>
                    {zitat_edit_url && <a
                        className={"changelink"}
                        href={zitat_edit_url}
                        target={"_blank"}
                        title={"Beleganalyse bearbeiten"}
                    >ID-{pk}</a>}

                    <div>
                        <div className={"text"}>
                            <span className={"quotes-left"} />
                            <span dangerouslySetInnerHTML={{ __html: text_html }} />
                            <span className={"quotes-right"} />
                        </div>
                    </div>
                    <table>
                    <tbody>
                        <tr>
                            <td>
                                <b>Quelle</b>
                            </td>
                            <td>
                                {source.link
                                    ? <a href={source.link} target={"_blank"} className={"source external-link"}>
                                        {source.citation}
                                    </a>
                                    : <span className={"source"}>{source.citation}</span>
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>

                                <b>Metapher</b>
                            </td>
                            <td>
                                <div className={"metapher"}>
                                    <div className={"name"}>
                                        <SearchLink
                                            textHtml={metapher.text}
                                            model={"Metapher"} field={"Text"}
                                        />
                                        &nbsp;
                                        {metapher.edit_url && <a
                                            className={"changelink"}
                                            href={metapher.edit_url}
                                            target={"_blank"}
                                            title={"Metapher bearbeiten"}
                                        />}
                                    </div>
                                    {metapher.meaning || metapher.short_meaning ? (
                                        !metapher.meaning
                                            ? <div className={"meaning"}>{metapher.short_meaning}</div>
                                            : <div className={"meaning"}>{metapher.meaning}</div>
                                    ) : null}
                                </div>
                                    {
                                        metapher.comment && metapher.comment.length > 0 ?
                                            <div className={"comment"}>
                                                <b>Kommentar:</b>
                                                <p>
                                                    <span dangerouslySetInnerHTML={{ __html: metapher.comment }} />
                                                </p>
                                            </div>
                                            : null
                                    }
                            </td>

                        </tr>

                        {metapher.types && metapher.types.length ? (
                            <tr>
                                <td>
                                    <b>Metapherntyp</b>

                                </td>
                                <td>
                                    <div className={"metapher-types"}>
                                        {metapher.types.map((type, i) => (
                                            <span key={i}>
                                                <SearchLink text={type} model={"Metapher"} field={"Typ"} />
                                                {i + 1 < metapher.types.length ? <span>,</span> : null}
                                                &nbsp;
                                </span>
                                        ))}
                                    </div>
                                </td>
                            </tr>
                        ) : null}

                        {metapher.original_language ? (
                            <tr>
                                <td>
                                    <b>Herkunftssprache</b>

                                </td>
                                <td>
                                    {metapher.original_language.charAt(0).toUpperCase() + metapher.original_language.slice(1)}
                                </td>
                            </tr>
                        ) : null}

                        {metapher.see_also && metapher.see_also.length ? (
                            <tr>
                                <td>
                                    <b>Siehe auch</b>
                                </td>
                                    <td>
                                        {this.renderSeeAlso(metapher.see_also)}
                                    </td>
                            </tr>
                        ) : null}

                        {metapher.history ? (
                            <tr>
                                <td>
                                    <b>Geschichte</b>

                                </td>
                                <td>
                                    <span
                                        dangerouslySetInnerHTML={
                                            {
                                                __html: this.reduceText(metapher.history, pk)
                                            }
                                        } />
                                    &nbsp;
                                    {
                                        metapher.history.length > DESC_LENGTH ?
                                            <a onClick={() => this.showMore(pk)} id={"show-more-btn" + pk}>(weiterlesen)</a>
                                            : null
                                    }
                                </td>
                            </tr>
                        ) : null}

                        {metapher.literature ? (
                            <tr>
                                <td>
                                    <b>Literaturangaben</b>

                                </td>
                                <td>
                                    <span dangerouslySetInnerHTML={{ __html: metapher.literature }} />
                                </td>
                            </tr>
                        ) : null}
                        </tbody>
                    </table>

                    {
                        comment && comment.length > 0 ?
                            <div className={"comment"}>
                                <b>Kommentar:</b>
                                <p>
                                    <span dangerouslySetInnerHTML={{ __html: comment }} />
                                </p>
                            </div>
                            : null
                    }



                </div>

                <div className={"small-4 cell"}>
                    <p className={"dinge-intro"}>Dinge in diesem Zitat</p>
                    {things.map((thing, i) => (
                        <div className={"things"}>
                            <Ding {...thing} key={i} />
                        </div>
                    ))}
                </div>

                <div className={"small-12 cell zeiterfahrung"}>
                    {metapher.time_experiences && Object.keys(metapher.time_experiences).length ? (
                        <table>
                        <tbody>
                            <tr>
                                <td>
                                    <b>Zeiterfahrungen</b>
                                </td>
                                <td>
                                    <Tree items={metapher.time_experiences}
                                        model={"Metapher"}
                                        field={"Zeiterfahrung"}
                                    />
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default Zitat;


// WEBPACK FOOTER //
// ./cms_plugins/zitat_display/js/components/Zitat.js